import activity from "./activity";
import ai from "./ai";
import cont from "./cont";
import develop from "./develop";
import extension from "./extension";
import mentalTest from "./mentalTest";
import notice from "./notice";
import personnel from "./personnel";
import statistics from "./statistics";
import system from "./system";

/**
 * 华博特项目接口文档
 */
export default {
  activity,
  ai,
  cont,
  develop,
  extension,
  mentalTest,
  notice,
  personnel,
  statistics,
  system,
};
